import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NoMatchView from '../no-match-view';
import { HoverNavigationProvider } from './hover-navigation-context';
import { UserAppsProvider } from './user-apps-context';
import { NavigationModeProvider } from './navigation-mode-context';
import XYCursorNavigation from './xy-cursor-navigation';
import Welcome from './welcome';
import Store from './store';
import Profile from './profile';
// TODO: Re-enable for next sprint — Subscription page
// import Subscription from './subscription';
import YesNo from './yes-no';
import Connect4 from './connect4';
import Game2048 from './game2048';
import Buddy from './buddy';
import GridApp from './grid';
import Radio from './radio';
import { GridDataProvider } from './grid/grid-data-context';

export default function ApplicationsViews() {
    return (
        <HoverNavigationProvider>
        <UserAppsProvider>
        <NavigationModeProvider>
        <GridDataProvider>
            <XYCursorNavigation />
            <Routes>
                <Route path='/' element={<Welcome />} />
                <Route path='/store' element={<Store />} />
                <Route path='/profile' element={<Profile />} />
                {/* TODO: Re-enable for next sprint — Subscription page */}
                {/* <Route path='/subscription' element={<Subscription />} /> */}
                <Route path='/yes-no' element={<YesNo />} />
                <Route path='/connect4' element={<Connect4 />} />
                <Route path='/2048' element={<Game2048 />} />
                <Route path='/buddy' element={<Buddy />} />
                <Route path='/grid' element={<GridApp />} />
                <Route path='/radio' element={<Radio />} />
                <Route path="*" element={<NoMatchView />} />
            </Routes>
        </GridDataProvider>
        </NavigationModeProvider>
        </UserAppsProvider>
        </HoverNavigationProvider>
    );
}
